import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./utils.js";
export function Input({ className, ...props }) {
    return (_jsx("input", { className: cn("flex h-10 max-lg:h-11 w-full rounded-xl border border-stone-300 bg-surface px-3.5 text-sm text-stone-950 shadow-xs outline-none transition placeholder:text-stone-400 hover:border-stone-400 focus:border-emerald-700 focus:ring-3 focus:ring-emerald-700/12 disabled:cursor-not-allowed disabled:bg-stone-100 disabled:opacity-70", className), ...props }));
}
